(function () {
  // Bail out when the Inbox app embed isn't on the page: its loader script is
  // server-rendered, so its absence means no chat widget can ever appear and
  // there is nothing to observe.
  if (
    !document.getElementById('shopify-chat-bundle-selector') &&
    !document.querySelector('shopify-agent, shopify-chat, #ShopifyChat')
  ) {
    return;
  }

  // Shopify Inbox ships two widgets: the new agent chat (<shopify-agent> host,
  // server-rendered at the end of <body>; some stores get <shopify-chat> instead),
  // positioned via the registered --shopify-agent-activator-offset custom property,
  // and the legacy #ShopifyChat (positioned via inline `bottom`). The bundle
  // selector picks one at runtime, so all are supported here.
  var style = document.createElement('style');
  style.textContent =
    '#ShopifyChat{bottom:20px;left:8px!important;transition:bottom .2s ease}' +
    '#ShopifyChat,shopify-chat,shopify-agent{opacity:0;visibility:hidden;transition:opacity .3s ease,visibility 0s .3s}' +
    '#ShopifyChat.chat-visible,shopify-chat.chat-visible,shopify-agent.chat-visible{opacity:1;visibility:visible;transition:opacity .3s ease}';
  document.head.appendChild(style);

  var chat, isAgent, footer, stickyAtc;
  var footerTop = 0, lastOffset = 0;
  var ticking = false, chatOpen = false, hideTimer = 0;

  function setOffset(px) {
    if (isAgent) {
      chat.style.setProperty('--shopify-agent-activator-offset', px + 'px');
    } else {
      chat.style.bottom = px + 'px';
    }
  }

  function updateBottom() {
    if (chatOpen) {
      // The agent panel's height is derived from the same offset, so hold the
      // default resting offset; the legacy panel expects to sit flush with the
      // viewport bottom while open.
      var resting = isAgent ? 20 : 0;
      if (lastOffset !== resting) { lastOffset = resting; setOffset(resting); }
      return;
    }
    if (!stickyAtc) stickyAtc = document.querySelector('.sticky-atc');
    var offset = 20;
    if (stickyAtc) {
      var rect = stickyAtc.getBoundingClientRect();
      if (rect.height > 0 && rect.bottom <= window.innerHeight) {
        offset = rect.height + 10;
      } else if (lastOffset > 20 && rect.top < window.innerHeight + 10) {
        offset = lastOffset;
      }
    }
    if (offset !== lastOffset) {
      lastOffset = offset;
      setOffset(offset);
    }
  }

  function isOpen() {
    return chat.hasAttribute('open') || chat.getAttribute('is-open') === 'true';
  }

  function update() {
    if (chatOpen || window.scrollY + window.innerHeight >= footerTop) {
      clearTimeout(hideTimer);
      hideTimer = 0;
      updateBottom();
      chat.classList.add('chat-visible');
    } else if (chat.classList.contains('chat-visible') && !hideTimer) {
      // Mobile momentum scroll fires scroll events continuously for a second
      // or more; only arm the timer once (instead of resetting it on every
      // event) so the fade-out actually completes instead of being pushed
      // back for as long as the scroll keeps generating events.
      hideTimer = setTimeout(function () {
        chat.classList.remove('chat-visible');
        hideTimer = 0;
      }, 300);
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!chat) {
      chat = document.querySelector('shopify-agent, shopify-chat');
      if (chat) {
        isAgent = true;
      } else {
        chat = document.querySelector('#ShopifyChat');
      }
      if (!chat) return;
      chatOpen = isOpen();
      new MutationObserver(function () {
        var open = isOpen();
        if (open !== chatOpen) {
          chatOpen = open;
          updateBottom();
        }
      }).observe(chat, { attributes: true, attributeFilter: ['open', 'is-open'] });
    }
    if (!footer) {
      footer = document.querySelector('footer');
      if (footer) {
        footerTop = footer.offsetTop;
        new ResizeObserver(function () { footerTop = footer.offsetTop; }).observe(document.body);
      }
    }
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
})();
